<template>
  <div
    class="flex items-center gap-4 rounded-md bg-neutral-100 px-4 py-2 text-neutral-800"
  >
    <div class="relative">
      <img
        v-if="showThumbnail"
        :src="upload.url"
        :alt="upload.originalName"
        class="h-12 w-12 rounded-md object-cover"
        @error="thumbnailFailed = true"
      />
      <TIcon v-else size="48" name="upload" />
      <TIcon
        size="24"
        name="check_circle_fill"
        class="text-success absolute top-7 left-7 rounded-full bg-white"
      />
    </div>
    <div class="grow">
      <div class="">{{ upload.originalName }}</div>
    </div>
    <div>
      <TButton
        v-if="props.showDelete"
        type="text"
        color="danger"
        icon="trash"
        @click="
          emit('delete');
          fileHandler.delete();
        "
      />
    </div>
  </div>
</template>
<script setup lang="ts">
import { computed, ref } from 'vue';
import { useGlobalDependencyProvider } from '@teachino/shared-util';
import { Upload } from './upload';
import TIcon from '../Icon/TIcon.vue';
import type { FileHandler } from './file-handler';
import TButton from '../Button/TButton.vue';

const props = withDefaults(
  defineProps<{
    upload: Upload;
    fileHandler: FileHandler;
    showDelete?: boolean;
  }>(),
  {
    showDelete: true,
  },
);

const emit = defineEmits<{ delete: [] }>();

const config = useGlobalDependencyProvider().inject('config');
const thumbnailFailed = ref(false);

const isImage = computed(() =>
  config
    .uploadConfig()
    .imageUpload.allowedExtensions.some((extension) =>
      props.upload.originalName.toLowerCase().endsWith(extension),
    ),
);

const showThumbnail = computed(() => isImage.value && !thumbnailFailed.value);
</script>
